import { render, staticRenderFns } from "./traceData.vue?vue&type=template&id=1e6faff6&scoped=true"
import script from "./traceData.vue?vue&type=script&lang=js"
export * from "./traceData.vue?vue&type=script&lang=js"
import style0 from "./traceData.vue?vue&type=style&index=0&id=1e6faff6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6faff6",
  null
  
)

export default component.exports